var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ENV from 'config/env';
import anime from 'animejs/lib/anime.es';
// Components
import FullScreenLoader from '../../../../common/components/ui/loaders/FullScreenLoader.vue';
import Icon from '../../../../common/UIToolKit/Icon.vue';
import PageNotFound from 'ui/v1/pages/PageNotFound.vue';
import { Mutation, namespace } from 'vuex-class';
import { JobList } from 'packages/job_lists/JobList';
import { Pagination } from 'packages/core/Pagination';
import JobListNavigation from '../components/Navigation.vue';
import UiSpreadPaginationControls from '../../../../ui/v1/controls/UiSpreadPaginationControls.vue';
import UiTextInput from '../../../../ui/v1/controls/UiTextInput.vue';
import VueMultiselect from 'vue-multiselect/src/Multiselect.vue';
import UiButton from '../../../../ui/v1/controls/UiButton.vue';
import { PlaceholderHelper } from 'packages/email/PlaceholderHelper';
import BotView from 'apps/public/src/views/BotView.vue';
import Meta from 'common/mixins/Meta.mixin';
import CookiePreferenceFooter from 'apps/public/src/components/CookiePreferenceFooter.vue';
var jobListsModule = namespace('jobLists');
var JobListView = /** @class */ (function (_super) {
    __extends(JobListView, _super);
    function JobListView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.location = null;
        _this.search = '';
        _this.defaultLocation = { name: '', value: null };
        _this.askForPreference = false;
        return _this;
    }
    Object.defineProperty(JobListView.prototype, "botUrl", {
        get: function () {
            return ENV.APPS.PUBLIC.URL + "bot/" + this.jobList.botId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobListView.prototype, "locations", {
        get: function () {
            return __spreadArray([this.defaultLocation], this.cities.map(function (location) { return ({
                name: location.name,
                value: location.name.toLocaleLowerCase(),
            }); }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobListView.prototype, "title", {
        get: function () {
            return (this.jobList) ? PlaceholderHelper.convertPlaceholdersToValues(this.jobList.title) : '\u2026';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobListView.prototype, "heroImage", {
        get: function () {
            return this.jobList && this.jobList.appearance && this.jobList.appearance.heroImage
                ? this.jobList.appearance.heroImage.url
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobListView.prototype, "logo", {
        get: function () {
            return this.jobList && this.jobList.appearance && this.jobList.appearance.logo
                ? this.jobList.appearance.logo.url
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobListView.prototype, "accessToken", {
        get: function () {
            return this.$route.query.accessToken;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobListView.prototype, "jobListQuery", {
        get: function () {
            return !this.accessToken ? {} : {
                accessToken: this.accessToken,
            };
        },
        enumerable: false,
        configurable: true
    });
    JobListView.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, perPage, page, search;
            return __generator(this, function (_b) {
                _a = this.$route.query, perPage = _a.perPage, page = _a.page, search = _a.search;
                this.search = search;
                this.landingPagePagination.perPage = (perPage) ? Math.abs(parseInt(perPage)) : 20;
                this.landingPagePagination.currentPage = (page) ? Math.abs(parseInt(page)) : 1;
                return [2 /*return*/];
            });
        });
    };
    JobListView.prototype.loadScripts = function () {
        this.$emit('loadScripts');
    };
    JobListView.prototype.scrollToJobLists = function () {
        anime({
            targets: window.document.scrollingElement || window.document.body || window.document.documentElement,
            scrollTop: this.$refs.header.offsetTop - 20,
            easing: 'easeInOutQuad',
            duration: 700,
        });
    };
    JobListView.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.getCities(this.jobListId ? this.jobListId : this.jobList.stringIdentifier);
                        if (!!this.jobList) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getJobListFromIdString({
                                stringId: this.jobListId,
                                accessToken: this.accessToken,
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.jobListNotFound) {
                            return [2 /*return*/];
                        }
                        this.$app.languageService.setLanguage(this.jobList.locale);
                        document.querySelector('html').lang = this.jobList.locale;
                        this.addMeta();
                        this.setAppearance(this.jobList.appearance);
                        return [4 /*yield*/, Promise.all([
                                this.doSearch(),
                                this.getPrivacyPolicyUrl(),
                            ])];
                    case 3:
                        _a.sent();
                        this.addMeta();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(JobListView.prototype, "defaultLocationSelection", {
        get: function () {
            this.defaultLocation.name = this.$t('public.anywhere');
            this.defaultLocation.value = null;
            if (this.location == null) {
                this.location = this.defaultLocation;
            }
            return this.location;
        },
        set: function (value) {
            this.location = value;
        },
        enumerable: false,
        configurable: true
    });
    JobListView.prototype.doSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, query;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            stringId: this.jobList.stringIdentifier,
                            paging: this.landingPagePagination,
                            search: this.search,
                            location: this.location.value,
                            accessToken: this.accessToken,
                        };
                        query = {
                            page: this.landingPagePagination.currentPage.toString(),
                            perPage: this.landingPagePagination.perPage.toString(),
                        };
                        if (this.search) {
                            query.search = this.search;
                        }
                        if (this.location) {
                            query.location = this.location.value;
                        }
                        if (this.accessToken) {
                            query.accessToken = this.accessToken;
                        }
                        this.$router.replace({
                            query: query,
                        }, function () { return null; }, function () { return null; });
                        return [4 /*yield*/, this.getPagesForStringId(params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    JobListView.prototype.addMeta = function () {
        var sharing = this.jobList.sharingSettings;
        this.setMetaTitles(PlaceholderHelper.convertPlaceholdersToValues(this.jobList.title));
        if (sharing.description) {
            this.setMetaDescriptions(sharing.description);
        }
        if (sharing.image) {
            this.setMetaImage(sharing.image.uri);
        }
        this.setTwitterCard(!!sharing.image);
    };
    var _a, _b, _c;
    __decorate([
        jobListsModule.State,
        __metadata("design:type", Boolean)
    ], JobListView.prototype, "loadingJobList", void 0);
    __decorate([
        jobListsModule.State,
        __metadata("design:type", Boolean)
    ], JobListView.prototype, "loadingLandingPages", void 0);
    __decorate([
        jobListsModule.State,
        __metadata("design:type", typeof (_a = typeof JobList !== "undefined" && JobList) === "function" ? _a : Object)
    ], JobListView.prototype, "jobList", void 0);
    __decorate([
        jobListsModule.State,
        __metadata("design:type", Boolean)
    ], JobListView.prototype, "jobListNotFound", void 0);
    __decorate([
        jobListsModule.State,
        __metadata("design:type", Array)
    ], JobListView.prototype, "landingPages", void 0);
    __decorate([
        jobListsModule.State,
        __metadata("design:type", typeof (_b = typeof Pagination !== "undefined" && Pagination) === "function" ? _b : Object)
    ], JobListView.prototype, "landingPagePagination", void 0);
    __decorate([
        jobListsModule.State('locations'),
        __metadata("design:type", typeof (_c = typeof Array !== "undefined" && Array) === "function" ? _c : Object)
    ], JobListView.prototype, "cities", void 0);
    __decorate([
        jobListsModule.State,
        __metadata("design:type", String)
    ], JobListView.prototype, "privacyPolicyUrl", void 0);
    __decorate([
        jobListsModule.Mutation,
        __metadata("design:type", Function)
    ], JobListView.prototype, "setLandingPagePagination", void 0);
    __decorate([
        jobListsModule.Action,
        __metadata("design:type", Function)
    ], JobListView.prototype, "getCities", void 0);
    __decorate([
        jobListsModule.Action('getListForStringId'),
        __metadata("design:type", Function)
    ], JobListView.prototype, "getJobListFromIdString", void 0);
    __decorate([
        jobListsModule.Action('getLandingPagesForJobListByStringId'),
        __metadata("design:type", Function)
    ], JobListView.prototype, "getPagesForStringId", void 0);
    __decorate([
        jobListsModule.Action,
        __metadata("design:type", Function)
    ], JobListView.prototype, "getPrivacyPolicyUrl", void 0);
    __decorate([
        Mutation('setAppearance'),
        __metadata("design:type", Object)
    ], JobListView.prototype, "setAppearance", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], JobListView.prototype, "jobListId", void 0);
    JobListView = __decorate([
        Component({
            components: {
                CookiePreferenceFooter: CookiePreferenceFooter,
                BotView: BotView,
                UiButton: UiButton,
                UiTextInput: UiTextInput,
                UiSpreadPaginationControls: UiSpreadPaginationControls,
                PageNotFound: PageNotFound,
                Icon: Icon,
                JobListNavigation: JobListNavigation,
                FullScreenLoader: FullScreenLoader,
                VueMultiselect: VueMultiselect,
            },
        })
    ], JobListView);
    return JobListView;
}(Mixins(Meta)));
export default JobListView;
